export default (text) => {
  if (text) {
    return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
  }

  return '';
};
